import React, { memo } from "react";

import Star from "@mui/icons-material/Star";
import StarBorder from "@mui/icons-material/StarBorder";
import type { IconButtonProps } from "@mui/material";
import { IconButton, Tooltip } from "@mui/material";

export type FavoriteButtonProps = {
  enabled: boolean;
  onClick: IconButtonProps["onClick"];
  disabled?: boolean;
  favoriteTitle: string;
  unfavoriteTitle: string;
  entityId?: number;
};

const FavoriteButton: React.FC<FavoriteButtonProps> = ({
  enabled,
  onClick,
  unfavoriteTitle,
  favoriteTitle,
  entityId,
  disabled = false,
}) => {
  return (
    <Tooltip placement="top" arrow title={enabled ? unfavoriteTitle : favoriteTitle}>
      <IconButton
        disabled={disabled}
        onClick={onClick}
        data-entity-is-favorite={enabled}
        data-entity-id={entityId}
      >
        {enabled ? <Star color="secondary" /> : <StarBorder />}
      </IconButton>
    </Tooltip>
  );
};

export default memo(FavoriteButton);
